/**
 * Wraps a function that returns a promise and catches any errors that occurs.
 * This is useful for the useMutation hook which returns a promise returning function
 * that can't be directly put in an onClick handler. Only use it when you don't care
 * about the error.
 */
export const depromisify = (fn: () => Promise<void>) => () => {
  fn().catch((error: unknown) => {
    console.error(error);
  });
};
